
import measureGetActions from './measure';

export * from './measure';

export function getActions(dispatch) {
    return {
        ...measureGetActions(dispatch)
    }
}
